import { momentWithLocale as moment } from '../locale/i18n.js';

export default function sanitize(obj, validKeys) {
    if (typeof obj !== 'object') {
        throw new Error('Sanitize requires a valid object');
    }

    if (!Array.isArray(validKeys)) {
        throw new Error('Sanitize requires an array of valid key strings');
    }

    return Object.keys(obj).reduce((acc, key) => {
        if (validKeys.indexOf(key) !== -1) {
            if ((key === 'departureDate' || key === 'returnDate') && obj[key] !== null) {
                acc[key] = moment(obj[key]).format('YYYY-MM-DD');
            } else {
                acc[key] = obj[key];
            }
        }
        return acc;
    }, {});
}
